import Box from '@mui/material/Box';
import Fade from '@mui/material/Fade';
import Stack from '@mui/material/Stack';

import { useAtomValue } from 'jotai';

import { getPublicRuntimeConfig } from '@watershed/config/utils/publicRuntimeConfig';
import { TestIds } from '@watershed/shared-universal/utils/testUtils';
import mixinSx from '@watershed/style/mixinSx';

import { adminBarVisibilityAtom } from '../../global-atoms/adminBarVisibilityAtom';
import { CurrentEnvironmentIndicator } from './CurrentEnvironmentIndicator';
import { DebugSessionIndicator } from './DebugSessionIndicator';
import { FlagOverridesIndicator } from './FlagOverridesIndicator';
import { LoginAsUserIndicator } from './LoginAsUserIndicator';
import { PrivilegedSessionIndicator } from './PrivilegedSessionIndicator';
import { adminChipBarLeftPositionStyles } from './useAdminBarLeftPosition';

/**
 * Shows a bar of admin tools at the bottom of the screen. Can be disabled with
 * the NEXT_PUBLIC_DISABLE_ADMIN_CHIP environment variable, and most content
 * only shows up for Watershed employees or login as users.
 */
export default function AdminBar() {
  const adminBarVisible = useAtomValue(adminBarVisibilityAtom);

  const disableAdminChip = !!getPublicRuntimeConfig(
    'NEXT_PUBLIC_DISABLE_ADMIN_CHIP'
  );

  if (disableAdminChip) {
    return null;
  }

  return (
    <Box
      data-testid={TestIds.AdminBar}
      sx={mixinSx(
        {
          display: 'flex',
          position: 'fixed',
          right: 8,
          bottom: 8,
          zIndex: 1299, // 1 less than MUI popovers.
          flexWrap: 'wrap',
          pointerEvents: !adminBarVisible ? 'none' : 'auto',
        },
        adminChipBarLeftPositionStyles
      )}
    >
      <Fade in={adminBarVisible}>
        <Stack direction="row" alignItems="center" gap={0.5}>
          <LoginAsUserIndicator />
          <CurrentEnvironmentIndicator />
          <PrivilegedSessionIndicator />
          <DebugSessionIndicator />
          <FlagOverridesIndicator />
        </Stack>
      </Fade>
    </Box>
  );
}
